
<modal
  size="full"
  :title="title"
  :open="open"
  @close="closeModal"
>
  <div class="grid">
    <section>
      <div v-if="card">
        <text-input
          id="search"
          v-model="searchQuery"
          label="Search"
          placeholder="Search for a card"
        />

        <div class="search-results">
          <align class="results-header" justify="space-between">
            <align small-gap>
              <h5>Search Results</h5>
              <icon-button
                as="router-link"
                target="_blank"
                :to="salesHistoryLink"
                icon="open_in_new"
                size="16"
                tooltip="Open in new tab"
              />
            </align>

            <align small-gap>
              <icon-button icon="insert_photo" :class="{ success: salesView === 'images' }" @click="salesView = 'images'; fetchSales(); viewSales = true" />
              <icon-button icon="cl_psa_image" :class="{ success: salesView === 'psa_images' }" @click="salesView = 'psa_images'; fetchSales(); viewSales = true" />
              <icon-button icon="receipt_long" :class="{ success: salesView === 'sales' }" @click="salesView = 'sales'; fetchSales(); viewSales = true" />
              <icon-button :icon="viewSales ? 'expand_less' : 'expand_more'" @click="viewSales = !viewSales" />
            </align>
          </align>

          <div v-if="viewSales">
            <div v-if="loadingSales" class="loading-container">
              <spinner inline />
            </div>

            <div v-else-if="searchResults.length > 0" class="search-scroll-container">
              <div v-if="salesView === 'sales'">
                <sales-list-item
                  v-for="item in searchResults"
                  :key="item.itemId"
                  :item="item"
                  as="a"
                  split
                  :href="item.url"
                  target="_blank"
                />
              </div>

              <div v-else-if="salesView === 'images'" class="possible-images">
                <div class="grid">
                  <div
                    v-for="item in searchResults"
                    :key="item.itemId"
                    class="possible-image"
                    @click="selectImage(item.image)"
                  >
                    <img :src="item.image" />

                    <div v-if="item.imageDimensions" class="dimensions">
                      {{ item.imageDimensions.width }}x{{ item.imageDimensions.height }}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="search-scroll-container">
              <div v-if="salesView === 'psa_images'" class="possible-images">
                <div class="grid">
                  <div
                    v-for="image in psaImageResults"
                    :key="image.id"
                    class="possible-image"
                    @click="selectImage(image.url)"
                  >
                    <img :src="image.url" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="card">
          <card-image-upload v-model="card" @result="handleUpload" />
        </div>
      </div>
    </section>

    <section>
      <div v-if="card">
        <card-details-fields v-model="card" />

        <card-advanced-fields v-model="card" @selectImage="selectImage" />

        <div v-if="editing && card" class="dates">
          <div>Added: {{ $filters.date(card.dateAdded) }}</div>
          <br />
        </div>
      </div>
    </section>
  </div>

  <template #footer>
    <align justify="space-between">
      <div class="button-row">
        <btn
          :disabled="disabled"
          :loading="saving"
          @click="submit"
        >
          Save
        </btn>

        <btn
          v-if="canDelete"
          kind="error"
          loading-text="Deleting"
          :loading="deleting"
          @click="deleteCard"
        >
          Delete
        </btn>

        <btn
          v-else
          kind="secondary"
          @click="resetForm"
        >
          Reset
        </btn>
      </div>

      <btn
        kind="ebay"
        :disabled="disableGenerateQuery"
        @click="generateEbayQuery"
      >
        Generate Query
      </btn>
    </align>
  </template>
</modal>
